// extracted by mini-css-extract-plugin
export default {"container":"StringStrengthMeter_container__jBbkr","labels":"StringStrengthMeter_labels__oSiwp"};